var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "s-orders-tab"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffGroupBuyingOrdersStatus',
        params: {
          status: 'processing'
        }
      }
    }
  }, [_vm._v(" 跟團中 ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffGroupBuyingOrdersStatus',
        params: {
          status: 'completed'
        }
      }
    }
  }, [_vm._v(" 已取貨 ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffGroupBuyingOrdersStatus',
        params: {
          status: 'invalid'
        }
      }
    }
  }, [_vm._v(" 已失效 ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }